export default "__VITE_ASSET__$xpKp6zK__";